module.exports = __webpack_public_path__ + "img/percent_stacked_bar.93f72e3f.svg";